import React, { useState } from "react";

const SliderOptions = ({ options, theme = "default", defaultValue, onChange, origin }) => {
  const [selected, setSelected] = useState(defaultValue || options[0]);

  const handleSelect = (option) => {
    setSelected(option);
    onChange?.(option);
  };

  const isTheme1 = theme === "theme1";
  const containerBg = isTheme1 ? "bg-gray-200/50" : "bg-gray-100";
  const containerPadding = isTheme1 ? "p-1" : "p-1"; // Same, but adjustable
  const activeBg = isTheme1 ? "bg-[#a6834d]" : "bg-white";
  const activeText = isTheme1 ? "text-white" : (options.includes('Candidate Demographics') ? "text-black" : "text-yellow-800");
  const buttonPadding = isTheme1 ? "px-6 py-1.5 text-sm" : "px-2 py-2 text-xs";
  const activeExtra = isTheme1 ? "" : "shadow";

  return (
    <div className={`flex ${containerBg} rounded-full ${containerPadding} shadow-sm ${origin === "adminDashboard" ? "w-[21rem]" : "w-fit"}`}>
      {options.map((option, index) => (
        <button
          key={option}
          onClick={() => handleSelect(option)}
          className={`
            font-medium rounded-full duration-500 flex-1
            ${buttonPadding}
            ${selected === option 
              ? `${activeBg} ${activeText} ${activeExtra}` 
              : (isTheme1 ? "text-gray-600 hover:text-gray-700" : "text-gray-600 hover:text-black")
            }
            ${isTheme1 ? "text-xs" : ""}
            ${index > 0 && !isTheme1 ? "-translate-x" : ""} 
          `}
        >
          {option}
        </button>
      ))}
    </div>
  );
};

export default SliderOptions;
